
<div class="pr-1 pt-0 pb-2 pl-2" style="position: relative;">
    <div class="bid-header primary--text">
        {{ manufacturer }} - {{ bidNumber }}
    </div>

    <div class="calculation-header pr-0 pl-2 v-flex" >
        <div class = "calculation-col-header elevator">

        </div>
        <div class = "calculation-col-header prices">
            Angebotspreis
        </div>
        <div class = "calculation-col-header prices">
            Kosten
        </div>
    </div>
    <div class="calculation-header pr-0 pl-2 v-flex" >
        <div class = "calculation-col-header elevator">
            {{ $t('inc.unit.elevatorNo') }}
        </div>
        <div class = "calculation-col-header price">
            Urspünglich
        </div>
        <div class = "calculation-col-header price">
            Empfohlen
        </div>
        <div class = "calculation-col-header price">
            Material
        </div>
        <div class = "calculation-col-header price">
            Lohn
        </div>
    </div>

    <div v-for="(calculation, index) in bid.calculations"
         :key = "index"
         class="v-flex calculation-border pa-2 pr-0"
         :class="border(index)"
    >
        <div class="elevator">
            {{ calculation.unit.fabricNo }}
        </div>
        <div class="price">
            {{ money (calculation.priceOriginal) }}
        </div>
        <div class="price">
            {{ money (calculation.priceRecommended) }}
        </div>
        <div class="price">
            {{ money (calculation.costMaterial) }}
        </div>
        <div class="price">
            {{ money (calculation.costWage) }}
        </div>
    </div>
    <div class="v-flex calculation-border pa-2 bottom-border-radius background-selected" v-if="bid.calculations.length > 1">
        <div class="elevator background-selected">
            Summe
        </div>
        <div class="price ">
            {{ money (bid.priceOriginal) }}
        </div>
        <div class="price">
            {{ money (bid.priceRecommended) }}
        </div>
        <div class="price">
            {{ money (bid.costMaterial) }}
        </div>
        <div class="price">
            {{ money (bid.costWage) }}
        </div>
    </div>
</div>
